import packageJson from 'tv/package.json';
var proxyVersion = function (versionJsonResponse) {
    if (!versionJsonResponse) {
        return {
            version: '',
            isUpdated: false,
            lastUpdateDate: '',
        };
    }
    var version = packageJson.version;
    var downloadVersion = versionJsonResponse.version, lastUpdateDate = versionJsonResponse.lastUpdateDate;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    var updateVersion = Number.parseFloat(downloadVersion).toFixed(2);
    var currentVersion = Number.parseFloat(version).toFixed(2);
    var fixedLastUpdateDate = lastUpdateDate.split('-')[0];
    return {
        version: downloadVersion,
        isUpdated: updateVersion > currentVersion,
        lastUpdateDate: fixedLastUpdateDate,
    };
};
export default proxyVersion;
